import { getEnumObject } from '../utilities.js';

export const financialRecordTypes = {
  ALIEN: 2,
  ALIEN_REDUNDANT: 3,
  KNOWN: 1,
};

export default getEnumObject(financialRecordTypes);
